type Props = { props: Record<string, string | number | boolean> }

export function DiscountBadgePreview({ props: p }: Props) {
  return (
    <div className="flex justify-center py-2">
      <span
        className="px-4 py-2 rounded-full font-bold text-sm"
        style={{ backgroundColor: p.bgColor as string, color: p.textColor as string }}
      >
        {p.text as string}
      </span>
    </div>
  )
}
